var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_today",
    clipPath: "url(#clip0_417_15342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6665 2.50114H15.8332V0.834473H14.1665V2.50114H5.83317V0.834473H4.1665V2.50114H3.33317C2.4165 2.50114 1.6665 3.25114 1.6665 4.16781V17.5011C1.6665 18.4178 2.4165 19.1678 3.33317 19.1678H16.6665C17.5832 19.1678 18.3332 18.4178 18.3332 17.5011V4.16781C18.3332 3.25114 17.5832 2.50114 16.6665 2.50114ZM16.6665 17.5011H3.33317V8.33447H16.6665V17.5011ZM16.6665 6.66781H3.33317V4.16781H16.6665V6.66781Z",
    fill: "#8993A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_15342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.59bf211bacddb3c07b12331b2907e87c.svg";
export { ForwardRef as ReactComponent };